export async function checkForNewBuildAndReload() {
  try {
    const res = await fetch(`/asset-manifest.json?ts=${Date.now()}`, {
      cache: "no-store",
    });
    if (!res.ok) return;

    const manifest = await res.json();
    const buildId = manifest?.files?.["main.js"] || JSON.stringify(manifest);

    const STORAGE_KEY = "app_build_id";
    const RELOAD_KEY = "did_reload_for_new_build";

    const lastBuildId = localStorage.getItem(STORAGE_KEY);

    if (lastBuildId && lastBuildId !== buildId) {
      if (!sessionStorage.getItem(RELOAD_KEY)) {
        sessionStorage.setItem(RELOAD_KEY, "1");
        window.location.reload();
        return;
      }
    }

    localStorage.setItem(STORAGE_KEY, buildId);
  } catch {}
}
